<template>
  <el-select :value="value" @change="handleChange">
    <el-option
      v-for="item in formatModels"
      :class="{ 'bordered': checkEmptyModel(item.id) }"
      :key="item.model_name_origin"
      :label="item.model_name_origin"
      :value="item.model_name">
      <span>{{ item.model_name_origin }}</span>
      <el-tooltip v-if="item.tooltip">
        <div slot="content" class="tooltip-content">
          <div>{{ item.tooltip.line1 }}</div>
          <div>{{ item.tooltip.line2 }}</div>
        </div>
        <svgicon name="Info" style="width: 16px;" />
      </el-tooltip>
    </el-option>
  </el-select>
</template>

<script>
import { mapGetters } from 'vuex';
const EMPTY_MODEL_ID = 0;

export default {
  name: 'ModelTypeSelect',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      models: 'brandDetectionModels',
    }),
    formatModels() {
      const emptyModel = this.models.find(el => this.checkEmptyModel(el.id)) || {};
      const formatEmptyModel = {
        ...emptyModel,
        tooltip: {
          line1: 'If you run a project with this model, there will be no detections.',
          line2: 'But there will be an opportunity to go into the project and label the necessary brands and send the model for training',
        },
      };
      return [formatEmptyModel, ...this.models.filter(el => !this.checkEmptyModel(el.id))];
    },
  },
  methods: {
    checkEmptyModel(id) {
      return id === EMPTY_MODEL_ID;
    },
    handleChange(v) {
      this.$emit('input', v);
    },
  },
};
</script>

<style lang="scss" scoped>
.bordered {
  border-bottom: 1px solid var(--border-color);
}

.el-select-dropdown__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tooltip-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 250px;
}
</style>
